var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document-normal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-normal_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3334 10.9998H25.6667C29.3334 10.9998 29.3334 9.1665 29.3334 7.33317C29.3334 3.6665 27.5001 3.6665 25.6667 3.6665H18.3334C16.5001 3.6665 14.6667 3.6665 14.6667 7.33317C14.6667 10.9998 16.5001 10.9998 18.3334 10.9998Z",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.3333 7.37012C35.4383 7.70012 38.5 9.95512 38.5 18.3335V29.3335C38.5 36.6668 36.6667 40.3335 27.5 40.3335H16.5C7.33333 40.3335 5.5 36.6668 5.5 29.3335V18.3335C5.5 9.97345 8.56167 7.70012 14.6667 7.37012",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentNormal);
export default __webpack_public_path__ + "static/media/document-normal.05b57fb94a2ce975f96cc3fa822fee41.svg";
export { ForwardRef as ReactComponent };